import { StyledSystemProps } from '@/atoms/typography'
import { Color } from '@/styles/colors'
import { theme } from '@/styles/theme'

interface TypographyStyles {
  publicH1: StyledSystemProps
  H1: StyledSystemProps
  H3: StyledSystemProps
  H2: StyledSystemProps
  InputText: StyledSystemProps
  Paragraph: StyledSystemProps
  Log: StyledSystemProps
  SmallText: StyledSystemProps
  Label: StyledSystemProps
  PublicLabel: StyledSystemProps
  InputSmallText: StyledSystemProps
  ErrorText: StyledSystemProps
  NotificationText: StyledSystemProps
  ButtonText: StyledSystemProps
  ButtonSmallText: StyledSystemProps
  Legend: StyledSystemProps
  TabText: StyledSystemProps
}

export const typographyStyles: TypographyStyles = {
  publicH1: {
    fontSize: theme.fonts.fontSize46,
    fontWeight: theme.fonts.fontWeightMedium,
    letterSpacing: '0.25px',
    lineHeight: 1.4,
    fontFamily: theme.fonts.headingFont,
    color: Color.HEADING,
    as: 'h1',
    margin: 0,
  },
  H1: {
    fontSize: [theme.fonts.fontSize24, theme.fonts.fontSize28],
    fontWeight: theme.fonts.fontWeightNormal,
    letterSpacing: theme.fonts.letterSpacing,
    lineHeight: 1.5,
    fontFamily: theme.fonts.headingFont,
    color: Color.HEADING,
    as: 'h1',
    margin: 0,
  },
  H2: {
    fontSize: theme.fonts.fontSize18,
    fontWeight: theme.fonts.fontWeightMedium,
    fontFamily: theme.fonts.headingFont,
    letterSpacing: theme.fonts.letterSpacing,
    color: Color.HEADING,
    as: 'h2',
    margin: 0,
  },
  H3: {
    fontSize: theme.fonts.fontSize14,
    fontWeight: theme.fonts.fontWeightBold,
    letterSpacing: theme.fonts.letterSpacing,
    fontFamily: theme.fonts.headingFont,
    color: Color.HEADING,
    as: 'h3',
    margin: 0,
  },
  Paragraph: {
    fontSize: theme.fonts.fontSize13,
    fontWeight: theme.fonts.fontWeightNormal,
    letterSpacing: theme.fonts.letterSpacing,
    fontFamily: theme.fonts.textFont,
    color: Color.PARAGRAPH,
    as: 'p',
    margin: 0,
  },
  Log: {
    fontSize: theme.fonts.fontSize13,
    fontWeight: theme.fonts.fontWeightNormal,
    letterSpacing: theme.fonts.letterSpacing,
    fontFamily: theme.fonts.textCondensedFont,
    color: Color.PARAGRAPH,
    as: 'div',
    margin: 0,
  },
  NotificationText: {
    fontSize: theme.fonts.fontSize12,
    fontWeight: theme.fonts.fontWeightNormal,
    letterSpacing: theme.fonts.letterSpacing,
    fontFamily: theme.fonts.textFont,
    color: Color.HEADING,
    as: 'p',
    margin: 0,
  },
  SmallText: {
    fontSize: theme.fonts.fontSize10,
    fontWeight: theme.fonts.fontWeightNormal,
    letterSpacing: theme.fonts.letterSpacing,
    fontFamily: theme.fonts.textFont,
    color: Color.PARAGRAPH,
    as: 'p',
    margin: 0,
  },
  Label: {
    fontSize: theme.fonts.fontSize12,
    fontWeight: theme.fonts.fontWeightNormal,
    letterSpacing: theme.fonts.letterSpacing,
    fontFamily: theme.fonts.textCondensedFont,
    color: Color.LABEL,
    as: 'label',
    margin: 0,
  },
  PublicLabel: {
    fontSize: theme.fonts.fontSize18,
    fontWeight: theme.fonts.fontWeightMedium,
    letterSpacing: '0.5px',
    fontFamily: theme.fonts.textFont,
    color: Color.LABEL,
    as: 'label',
    margin: 0,
  },
  InputText: {
    fontSize: theme.fonts.fontSize16,
    fontWeight: theme.fonts.fontWeightNormal,
    letterSpacing: theme.fonts.letterSpacing,
    fontFamily: theme.fonts.textCondensedFont,
    color: Color.HEADING,
    as: 'p',
    margin: 0,
  },
  InputSmallText: {
    fontSize: theme.fonts.fontSize14,
    fontWeight: theme.fonts.fontWeightNormal,
    letterSpacing: theme.fonts.letterSpacing,
    fontFamily: theme.fonts.textCondensedFont,
    color: Color.HEADING,
    as: 'p',
    margin: 0,
  },
  ErrorText: {
    fontSize: theme.fonts.fontSize12,
    fontWeight: theme.fonts.fontWeightNormal,
    letterSpacing: theme.fonts.letterSpacing,
    fontFamily: theme.fonts.textFont,
    color: Color.ERROR,
    as: 'p',
    margin: 0,
  },
  ButtonText: {
    fontSize: [theme.fonts.fontSize13, theme.fonts.fontSize14],
    fontWeight: theme.fonts.fontWeightMedium,
    letterSpacing: theme.fonts.letterSpacing,
    fontFamily: theme.fonts.textFont,
    color: Color.VIOLET,
    textTransform: 'uppercase',
    as: 'p',
    margin: 0,
  },
  ButtonSmallText: {
    fontSize: theme.fonts.fontSize12,
    fontWeight: theme.fonts.fontWeightMedium,
    letterSpacing: theme.fonts.letterSpacing,
    fontFamily: theme.fonts.textFont,
    color: Color.VIOLET,
    textTransform: 'uppercase',
    as: 'p',
    margin: 0,
  },
  Legend: {
    fontSize: theme.fonts.fontSize14,
    fontWeight: theme.fonts.fontWeightBold,
    letterSpacing: theme.fonts.letterSpacing,
    fontFamily: theme.fonts.textCondensedFont,
    color: Color.HEADING,
    as: 'p',
    margin: 0,
  },
  TabText: {
    fontSize: theme.fonts.fontSize12,
    fontWeight: theme.fonts.fontWeightMedium,
    fontFamily: theme.fonts.textFont,
    color: Color.HEADING,
    textTransform: 'uppercase',
    as: 'p',
    margin: 0,
  },
}
